"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectOssImgDirective = injectOssImgDirective;

/**
 * @file ossimg 自动为img标签src属性添加oss图片后缀
 * @author fanweiwei
 * @date 2024-01-30
 */
function injectOssImgDirective(vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (vue && vue.directive) {
    var directiveHandler = function directiveHandler(el, binding) {
      var originalSrc = binding.value;

      if (!originalSrc) {
        /* eslint-disable no-console */
        console.error('ossimg 必须绑定值');
        return;
      } // 判断是否需要添加OSS参数
      // 是否是oss图片地址


      var isOssImgUrl = originalSrc.indexOf('//coolcdn.igetcool.com') > -1; // 是否已经添加过OSS参数

      var hasOssParam = originalSrc.indexOf('x-oss-process') > -1;

      if (isOssImgUrl && !hasOssParam) {
        // 先加载一个添加OSS参数压缩的小图
        // 判断符号
        var ossSymbol = originalSrc.indexOf('?') > -1 ? '&' : '?';
        el.setAttribute('src', "".concat(originalSrc).concat(ossSymbol, "x-oss-process=image/resize,m_lfit,w_", 100));

        el.onload = function () {
          // 压缩后的图片加载完毕后，再将原图加载出来
          // 创建一个新的Image对象
          var img = new Image();
          img.src = originalSrc; // 当图片加载完毕，再将img标签的src中的OSS参数删除

          img.onload = function () {
            el.setAttribute('src', originalSrc);
            el.onload = null;
          };
        };
      } else {
        el.setAttribute('src', originalSrc);
      }
    }; // ossimg 指令


    vue.directive('ossimg', {
      bind: directiveHandler,
      update: directiveHandler
    });
  }
}